import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import moment from 'moment';

import { fade } from '@material-ui/core/styles/colorManipulator';

import api from "../../../api/backend"

import Editor from './Editor'
import New from './New'

const styles = theme => ({
    heroUnit: {
        backgroundColor: theme.palette.grey[800],
        color: theme.palette.common.white,
    },
    heroContent: {
        maxWidth: 600,
        margin: '0 auto',
        padding: `${theme.spacing.unit * 8}px 0 ${theme.spacing.unit * 6}px`,
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(1100 + theme.spacing.unit * 3 * 2)]: {
            width: '100%',
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    cardGrid: {
        padding: `${theme.spacing.unit * 8}px 0`,
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing.unit,
        paddingRight: theme.spacing.unit,
        paddingBottom: theme.spacing.unit,
        paddingLeft: theme.spacing.unit * 10,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: 200,
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: fade(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing.unit * 2,
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing.unit * 3,
            width: 'auto',
        },
    },
    searchIcon: {
        width: theme.spacing.unit * 9,
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

class Register extends React.Component {
    state = {
        open: false,
        openSearch: false,
        list: [],
        courses: [],
        tmpCourses: [],
        level: '',
        course: '',
        term: '',
        page: 1,
        pageSize: 20,
        total: 0,
        loading: false,
    };

    handleChange = name => event => {
        this.setState({ [name]: event.target.value });
    };

    fetchList = () => {
        const { page, pageSize, term, level, course } = this.state
        this.setState({ loading: true })
        api.getAllRegisterCoursePaged(page, pageSize, term, level, course, true).then(([response, json]) => {
            if (response.status === 200) {
                this.setState({
                    list: json.items || [],
                    total: json.total || 0,
                    page: json.page || 1,
                    pageSize: json.pageSize || pageSize,
                })
            }
        }).catch(() => { }).finally(() => {
            this.setState({ loading: false })
        })
    }

    getCourses = () => {
        api.getAllCourses().then(([response, json]) => {
            if (response.status === 200) {
                this.setState({ courses: json, tmpCourses: json })
            }
        }).catch(() => { })
    }

    componentDidMount() {
        this.fetchList();
        this.getCourses();
    }

    onCreated = () => {
        this.setState({ page: 1 }, this.fetchList)
    }

    onUpdated = () => {
        this.fetchList()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage + 1 }, this.fetchList)
    }

    handleChangeRowsPerPage = (event) => {
        const newSize = parseInt(event.target.value, 10)
        this.setState({ pageSize: newSize, page: 1 }, this.fetchList)
    }

    applySearch = () => {
        this.setState({ page: 1, openSearch: false }, this.fetchList)
    }

    render() {
        const { classes } = this.props;
        const { list, page, pageSize, total, loading } = this.state;
        return (
            <div>
                <div className={classes.heroUnit}>
                    <div className={classes.heroContent}>
                        <Typography variant="display2" align="center" color="inherit" gutterBottom>
                            รายการลงทะเบียนเรียน
                        </Typography>
                        <div className={classes.search}>
                            <Button fullWidth style={{ color: 'white' }} onClick={() => { this.setState({ term: '', level: '', course: '', openSearch: true }) }}>ค้นหา</Button>
                            <Dialog fullWidth maxWidth="sm" disableBackdropClick disableEscapeKeyDown open={this.state.openSearch} onClose={() => { this.setState({ openSearch: false }) }}>
                                <DialogTitle>ค้นหารายการลงทะเบียน</DialogTitle>
                                <DialogContent>
                                    <form className={classes.container}>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="level-native-simple">ค้นหา</InputLabel>
                                            <TextField
                                                id="standard-term"
                                                className={classes.textField}
                                                value={this.state.term}
                                                onChange={this.handleChange('term')}
                                                margin="normal"
                                            />
                                        </FormControl>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="level-native-simple">ระดับชั้น</InputLabel>
                                            <Select
                                                value={this.state.level}
                                                input={<Input id="level-simple" />}
                                                onChange={(event) => {
                                                    let c = this.state.tmpCourses.filter((e) => {
                                                        return e.subject.level.includes(event.target.value)
                                                    })
                                                    this.setState({ level: event.target.value, courses: c })

                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 1">ประถมศึกษา ปีที่ 1</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 2">ประถมศึกษา ปีที่ 2</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 3">ประถมศึกษา ปีที่ 3</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 4">ประถมศึกษา ปีที่ 4</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 5">ประถมศึกษา ปีที่ 5</MenuItem>
                                                <MenuItem value="ประถมศึกษา ปีที่ 6">ประถมศึกษา ปีที่ 6</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 1">มัธยมศึกษา ปีที่ 1</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 2">มัธยมศึกษา ปีที่ 2</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 3">มัธยมศึกษา ปีที่ 3</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 4">มัธยมศึกษา ปีที่ 4</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 5">มัธยมศึกษา ปีที่ 5</MenuItem>
                                                <MenuItem value="มัธยมศึกษา ปีที่ 6">มัธยมศึกษา ปีที่ 6</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <FormControl className={classes.formControl} fullWidth>
                                            <InputLabel shrink htmlFor="course-simple">คอร์ส</InputLabel>
                                            <Select
                                                value={this.state.course}
                                                input={<Input id="course-simple" />}
                                                onChange={this.handleChange('course')}
                                            >
                                                <MenuItem value="">
                                                    <em>None</em>
                                                </MenuItem>
                                                {this.state.courses.map(course => (
                                                    <MenuItem key={course.course.id} value={course.course.title}>{course.course.title}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => { this.setState({ openSearch: false }) }} color="primary">
                                        Cancel
                                    </Button>
                                    <Button onClick={this.applySearch} color="primary">
                                        Ok
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </div>
                </div>
                <div className={classNames(classes.layout, classes.cardGrid)}>

                    <Grid container justify="center">
                        <Grid item xs={4}>
                            <New onCreated={this.onCreated} />
                        </Grid>
                    </Grid>
                    <br /> <br />
                    {loading && (
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '80px 0' }}>
                            <CircularProgress size={80} thickness={4} />
                            <Typography variant="title" color="textSecondary" style={{ marginTop: 24 }}>
                                กำลังโหลด...
                            </Typography>
                        </div>
                    )}
                    <Paper style={{ display: loading ? 'none' : 'block' }}>
                        <Table padding='dense'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>ชื่อนักเรียน</TableCell>
                                    <TableCell>คอร์ส</TableCell>
                                    <TableCell>วันที่เริ่ม</TableCell>
                                    <TableCell align="right">ประเภท</TableCell>
                                    <TableCell align="right">สถานะชำระเงิน</TableCell>
                                    <TableCell align="right">ชื่อเล่น</TableCell>
                                    <TableCell style={{ width: 200 }}>สถานะ</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {list.map(l => (
                                    <TableRow key={l.myCourse.id}>
                                        <TableCell component="th" scope="row">
                                            {l.user ? `${l.user.firstName} ${l.user.lastName}` : l.myCourse.user}
                                        </TableCell>
                                        <TableCell>{l.myCourse.course ? l.myCourse.course.title : ''}</TableCell>
                                        <TableCell>{l.myCourse.course ? moment(l.myCourse.course.startDate).format('DD/MM/YYYY') : ''}</TableCell>
                                        <TableCell align="right">{l.myCourse.type}</TableCell>
                                        <TableCell align="right">{l.myCourse.paymentStatus === 'Inprogress' ? <p style={{ color: 'red' }}>รอชำระ</p> : 'ชำระแล้ว'}</TableCell>
                                        <TableCell align="right">{l.user ? `${l.user.nickName}` : ''}</TableCell>
                                        <TableCell><Editor course={l.myCourse} onUpdateCompleted={this.onUpdated} /></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                        <TablePagination
                            component="div"
                            count={total}
                            rowsPerPage={pageSize}
                            page={page - 1}
                            backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                            nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                            onChangePage={this.handleChangePage}
                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 20, 50, 100]}
                            labelRowsPerPage="แสดงต่อหน้า:"
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} จาก ${count}`}
                        />
                    </Paper>
                </div>
            </div>
        );
    }
}

Register.propTypes = {
};

export default withStyles(styles)(Register);
